import React from 'react';

const Features = (props) => {
    return (
        <div className="contact">
            <div className="heading">Contact Us</div>
            <p >
                Vedant Nagani's Email : vedant.nagani@somaiya.edu
            </p>
            <p>
                Huzaifa Khilawala's Email : huzaifa.k@somaiya.edu
            </p>
        </div>
    )
}
export default Features;